import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  'order-ahead.request-profile-completion-popup.description': {
    id: 'order-ahead.request-profile-completion-popup.description',
    defaultMessage: "To place orders ahead of time, we'll need a few details.",
    description: 'description in popup to request user profile completion for order ahead',
  },
});
